import { c as _c } from "react/compiler-runtime";
import { memo, type PropsWithChildren } from 'react';
const VaultV2PerformanceLayout = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="gap-lg sm:gap-xl flex flex-col">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default memo(VaultV2PerformanceLayout);